import React from "react";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

export default function LogoutDialog({
  open,
  onClose,
  onConfirm,
  message = "Are you sure you want to log out of the admin console?",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: "18px", maxWidth: 380, p: 1 } }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
        <Avatar
          sx={{
            bgcolor: "rgba(178,133,133,0.15)",
            color: "#b28585",
            width: 58,
            height: 58,
          }}
        >
          <LogoutIcon />
        </Avatar>
      </Box>
      <DialogTitle sx={{ textAlign: "center", fontWeight: 700, color: "#511d00", pb: 0.5 }}>
        Log out?
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center", color: "text.secondary" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1.5 }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={onClose}
          sx={{ borderColor: "rgba(94,62,62,0.25)", color: "#5e3e3e" }}
        >
          Cancel
        </Button>
        <Button fullWidth variant="contained" color="primary" onClick={onConfirm}>
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}
